import React from 'react';
import AdminResourceManagerPage from '../../components/admin/AdminResourceManagerPage';

export default function AdminCpaDocumentsPage() {
  return (
    <AdminResourceManagerPage
      moduleKey="cpaDocuments"
      title="Documentos e relatórios da CPA"
      description="Atualize portarias, resoluções e relatórios exibidos na página da Comissão Própria de Avaliação. Use a categoria para separar composição e relatórios."
      createLabel="Novo documento da CPA"
      emptyMessage="Nenhum documento da CPA cadastrado."
      supportsTag
    />
  );
}
